import { computed } from 'vue'
import { AppAuthService, RequestedPermission, hasUserPermission } from '@prodcard/core'
import { refObservableValue } from '../common'

export function useAuthPermissions(authService: AppAuthService) {
  const currentUser = refObservableValue(authService.authorizedUser)
  const currentUserRole = refObservableValue(authService.role)
  const currentUserPermissions = refObservableValue(authService.permissions)

  const hasPermissions = (requestedPermission: RequestedPermission) => {
    if (currentUserPermissions.value) {
      return hasUserPermission(currentUserPermissions.value, requestedPermission)
    }

    return false
  }

  const currentMunicipalEntityId = computed(() => {
    return currentUser.value?.municipalEntityId
  })

  return {
    currentUser,
    currentUserRole,
    currentUserPermissions,
    hasPermissions,
    currentMunicipalEntityId,
  }
}
